module.exports = __webpack_public_path__ + "img/autorenew.5d1e30b6.svg";